export enum Mode {
    normal,
    moving,
    touchMoving,
    touchScaling
  }


  export enum FunctionMode{
    normal,
    addingStation,
    dragingStation,
    lineEditing,
    backgroundEditing,
    customBackground,
    editingCustomBackgroundPosition,
    selectingStation,
    choosingExistMap,
  }